<template>
<div>
  <form action="/create-checkout-session" method="POST">
    <button type="submit">Checkout</button>
  </form>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>